import { P, T4 } from 'ia-react-core';
import styled from 'styled-components';

export const StyledSection = styled.section`
  margin-top: 29px;
`;

export const StyledList = styled.ul`
  margin: 0;
  padding-left: 13px;
  li {
    font-size:9px;
  }
`;
export const StyledT = styled(T4)`
  margin-bottom: 14px;
`;
export const StyledP = styled(P)`
  margin-top: 11px;
  margin-bottom: 2px;
`;
